import { render, staticRenderFns } from "./faceCode.vue?vue&type=template&id=877bd204&scoped=true"
import script from "./faceCode.vue?vue&type=script&lang=js"
export * from "./faceCode.vue?vue&type=script&lang=js"
import style0 from "./faceCode.vue?vue&type=style&index=0&id=877bd204&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "877bd204",
  null
  
)

export default component.exports